export const environment = {
  production: false,
  useMockServer: false,
  apiBaseUrl: '#{ApiBaseUrl}#',
  clientBaseUrl: '#{ClientBaseUrl}#',
  httpRequestRetryCount: 0,
  friendlyErrors: 0,
  environmentName: '#{environmentName}#',
  buildVersion: '#{buildVersion}#'
};